"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bindFormItem = exports.useStateInFormItem = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var mobx_react_1 = require("mobx-react");
var formstate_x_1 = require("formstate-x");
var Form_1 = require("../Form");
// Input 向上（`FormItem`）注册 state 的 context
var stateRegisterCtx = react_1.createContext(function () { return undefined; });
/**
 * `FormItem` 中的 Input 组件通过这个 hook 把 state 传递给 `FormItem`
 * 注意适合 `FormItem` 对应单个 Input 组件的场景；若单个 `FormItem` 中包含了多个 Input 组件，
 * 需要通过给 `FormItem` 显式传递 prop state 来指定 `FormItem` 消费的 state
 */
function useStateInFormItem(state) {
    var registerState = react_1.useContext(stateRegisterCtx);
    react_1.useEffect(function () {
        registerState(state);
        return function () { return registerState(undefined); };
    }, [registerState, state]);
}
exports.useStateInFormItem = useStateInFormItem;
exports.default = mobx_react_1.observer(function FormItem(_a) {
    var stateFromProps = _a.state, children = _a.children, restProps = tslib_1.__rest(_a, ["state", "children"]);
    var _b = react_1.useState(), innerState = _b[0], setInnerState = _b[1];
    var state = stateFromProps !== null && stateFromProps !== void 0 ? stateFromProps : innerState;
    var validateProps = state != null ? bindFormItem(state) : null;
    return (react_1.default.createElement(stateRegisterCtx.Provider, { value: setInnerState },
        react_1.default.createElement(Form_1.FormItem, tslib_1.__assign({}, validateProps, restProps), children)));
});
/* 将 formstate-x state 绑定到 icecream FormItem 的辅助函数 */
function bindFormItem(state) {
    var hasError = state.hasError, error = state.error;
    // 在 form state 对应的界面层级，只需要展示 form 自身的校验结果即可
    // field 的校验结果应该展示在 field 对应的界面层级（通过 bindFormItem field 实现）
    if (state instanceof formstate_x_1.FormState) {
        hasError = state.hasOwnError;
        error = state.ownError;
    }
    if (hasError) {
        return {
            validateStatus: 'error',
            validateMessage: error
        };
    }
    // TODO: 有些 form item 需要在校验成功时显示成功样式（绿边）
    // 即 `validateStatus: 'success'`，需要支持下
    return { validateStatus: 'default' };
}
exports.bindFormItem = bindFormItem;
//# sourceMappingURL=FormItem.js.map